import { useRef } from "react";
import React, { useEffect, useState, useCallback } from "react";
import { faCheck, faTimes, faInfoCircle, faBlackboard, } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { Col, Container, Form, Row } from "react-bootstrap";
import "./UserRegistration.css";
import useAuth from "../../hooks/useAuth";
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import { Modal, Button } from 'react-bootstrap';
import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom';




const ChangeSthanUserPswd = () => {
  const back = async (e) => {
    e.preventDefault();
    // setSuccess(false);
  };
  const navigate = useNavigate();

  const axiosPrivate = useAxiosPrivate();
  const CREATE_STHAN_USER_PASSWORD = "create-sthan-user-password";
  const errRef = useRef();
  const sucssRef = useRef();
  const { Id, Name } = useParams();
  const [password, setPassword] = useState("");
  const [cnfPassword, setCnfPassword] = useState("");

  const [loading, setLoading] = useState(true);

  const [errMsg, setErrMsg] = useState("");
  const [sucssMsg, setSucssMsg] = useState("");

  const [showSuccessModal, setShowSuccessModal] = useState(false);



  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      var data = JSON.stringify({
        user_id: Id,
        password,
        confirm_password: cnfPassword,
      });

      const response = await axiosPrivate.post(CREATE_STHAN_USER_PASSWORD, data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });

      showMessage('success', response?.data?.message);
    } catch (err) {

      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.data?.message) {
        const errorMsg = typeof err.response.data.message === 'string'
          ? err.response.data.message
          : err.response.data.message.msg || "Unknown error"; // Extract inner msg if object
        setErrMsg(errorMsg);
      } else {
        setErrMsg("Password chnaging Failed");
      }
      errRef.current.focus();
    }


  };


  const showMessage = (type, message) => {
    if (type === 'error') {
      setErrMsg(message);
      setSucssMsg(""); // clear success message
    } else if (type === 'success') {
      setSucssMsg(message);
      setErrMsg(""); // clear error message
      setShowSuccessModal(true); // Show modal

      // Auto close after 10 seconds (10000 ms)
      setTimeout(() => {
        setShowSuccessModal(false);
      }, 5000);
    }
  };


  return (
    <>
      <Container>
        <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>
        <Modal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} centered>
          <Modal.Header closeButton>
            {/* <Modal.Title>Success</Modal.Title> */}
          </Modal.Header>
          <Modal.Body>
            <p>{sucssMsg}</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" onClick={() => setShowSuccessModal(false)}>
              OK
            </Button>
          </Modal.Footer>
        </Modal>
        {/* {success ? (
          <section>
            <h1>User successfully registred !</h1>
            <div className="flexGrow">
              <button onClick={back}>Back</button>
            </div>
          </section>
        ) : ( */}


        <section className="empbody">
          <p
            ref={errRef}
            className={errMsg ? "errmsg" : "offscreen"}
            aria-live="assertive"
          >
            {errMsg}
          </p>

          <p
            ref={sucssRef}
            className={sucssMsg ? "sucssmsg" : "offscreen"}
            aria-live="assertive"
          >
            {sucssMsg}
          </p>



          <div className="wrapper wrapper2">
            <form>
              <h3 class="arthik_head">Change Password of  <span className="colorChange">{Name}</span> </h3>

              <Row>

                <Col md={12}>
                  <div className="input-box arthik_input-box">
                    <input
                      type="password"
                      id="password"
                      placeholder="New Password"
                      autoComplete="off"
                      onChange={(e) => {
                        const value = e.target.value;
                        setPassword(value); // Always update password
                      }}
                      value={password}
                      required
                    />
                    <small
                      className={
                        password && password.length < 6
                          ? "text-danger mt-1 d-block"
                          : "d-none"
                      }
                    >
                      Keep typing — password must be 6 or more in length.
                    </small>
                  </div>
                </Col>

                <Col md={12}>
                  <div className="input-box arthik_input-box">
                    <input
                      type="password"
                      id="cnfPassword"
                      placeholder="Confirm Password"
                      autoComplete="off"
                      onChange={(e) => {
                        const value = e.target.value;
                        setCnfPassword(value); // Always update password
                      }}
                      value={cnfPassword}
                      required
                    />
                    <small
                      className={
                        cnfPassword && password !== cnfPassword
                          ? "text-danger mt-1 d-block"
                          : "d-none"
                      }
                    >
                      Passwords must match.
                    </small>
                  </div>
                </Col>

                <Col md={12}>
                  <button
                    type="button" // Important to prevent form submit
                    className="btn"
                    onClick={handleSubmit} // Call this for "Sign Up"
                    disabled={!password
                      || !cnfPassword
                      || password != cnfPassword}
                  >
                    Change Password
                  </button>
                </Col>
              </Row>
            </form>

          </div>

        </section>
        {/* )} */}
      </Container>
    </>
  );
};

export default ChangeSthanUserPswd;
